<template>
  <div class="acConnect__imgs">
    <div class="acConnect__imgs-item">
      <img
        v-if="singLogo"
        :src="getImgSrc(appName, true)"
        :alt="appName"
        width="48"
      >
      <img
        v-else-if="appState"
        :src="getImgSrc(appState, false)"
        :alt="appState"
        width="48"
      >
      <img
        v-else
        src="../../assets/logos/wechat.svg"
        alt="WeChat"
        width="48"
      >
      <slot />
    </div>
    <template v-if="!singLogo && !appState">
      <!-- or use svg-injector -->
      <!-- https://github.com/iconfu/svg-inject -->
      <img
        class="acConnect__imgs-arrow"
        src="../../assets/arrows-horizontal.svg"
      >
      <div class="acConnect__imgs-item">
        <img
          :src="getImgSrc(appName)"
          :alt="appName"
          width="45"
        >
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AppLogo',
  props: {
    appName: {
      type: String,
      default: 'yimian',
    },
    appState: {
      type: String,
      default: '',
    },
    singLogo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logos: ['yimian', 'hamlet', 'oneload', 'yisonar', 'oneview', 'yidrone', 'wechat'],
    };
  },
  methods: {
    getImgSrc(app = '', logo = true) {
      /* eslint-disable */
      let src = null;

      if (logo) {
        app = this.logos.includes(app.toLocaleLowerCase())
          ? app.toLocaleLowerCase() : 'default';
        app = `logos/${app}`;
      }

      try {
        src = require(`@/assets/${app}.svg`);
      } catch (err) {
        src = require('@/assets/logos/yimian.svg');
      }

      return src;
    },
  },
};
</script>



// WEBPACK FOOTER //
// AppLogo.vue?deaab98a